module.exports = __webpack_public_path__ + "img/quickresume4.3c33f707.png";